module.exports = __webpack_public_path__ + "static/media/entregador-carrefour.c7cb3b24.png";